import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.sixSection;

export default [
  {
    name: '牵引套件飞行踏板',
    info: ['牵制性武装套件'],
    mapIcon: require('./images/tab/A.png'),
    characteristicImgs: require('./images/A.jpg'),
    ...textInfo[0]
  },
  {
    name: '狙击套件飞行踏板',
    info: ['狙击性武装套件'],
    mapIcon: require('./images/tab/B.png'),
    characteristicImgs: require('./images/B.jpg'),
    ...textInfo[1]
  },
  {
    name: '狙击性武装套件',
    info: ['狙击性武装套件'],
    mapIcon: require('./images/tab/C.png'),
    characteristicImgs: require('./images/C.jpg'),
    ...textInfo[2]
  },
  {
    name: '近战套件飞行踏板',
    info: ['近战性武装套件'],
    mapIcon: require('./images/tab/D.png'),
    characteristicImgs: require('./images/D.jpg'),
    ...textInfo[3]
  },
  {
    name: '辅助套件飞行踏板',
    info: ['辅助性武装套件'],
    mapIcon: require('./images/tab/E.png'),
    characteristicImgs: require('./images/E.jpg'),
    ...textInfo[4]
  }
];
